/** @jsxImportSource @emotion/react */

export default () => (
  <a href="https://github.com/AndyLnd/colorpuzzle" css={{marginTop: 16}}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 43.4 42.4">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M21.7 0A21.7 21.7 0 0015 42.3c1 .2 1.4-.4 1.4-1v-3.7c-6 1.3-7.3-3-7.3-3-1-2.4-2.4-3.1-2.4-3.1-2-1.3.1-1.3.1-1.3 2.2.1 3.4 2.2 3.4 2.2 1.9 3.3 5 2.4 6.3 1.8.2-1.4.7-2.3 1.4-2.9-4.9-.5-10-2.4-10-10.7 0-2.4 1-4.3 2.3-5.8-.2-.6-1-2.8.2-5.8 0 0 1.8-.6 6 2.2a20.7 20.7 0 0110.9 0c4.1-2.8 6-2.2 6-2.2 1.1 3 .4 5.2.1 5.8a8.4 8.4 0 012.3 5.8c0 8.3-5.1 10.2-10 10.7.8.7 1.5 2 1.5 4v6c0 .6.4 1.2 1.5 1A21.7 21.7 0 0021.7 0"
      />
    </svg>
  </a>
);
